/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Invite_AcceptInputs */

const en_community_invite_accept = /** @type {(inputs: Community_Invite_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept Invitation`)
};

const id_community_invite_accept = /** @type {(inputs: Community_Invite_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terima Undangan`)
};

/** @type {(inputs: Community_Invite_AcceptInputs) => LocalizedString} */
const es_community_invite_accept = en_community_invite_accept;

/** @type {(inputs: Community_Invite_AcceptInputs) => LocalizedString} */
const fr_community_invite_accept = en_community_invite_accept;

/** @type {(inputs: Community_Invite_AcceptInputs) => LocalizedString} */
const de_community_invite_accept = en_community_invite_accept;

/** @type {(inputs: Community_Invite_AcceptInputs) => LocalizedString} */
const ja_community_invite_accept = en_community_invite_accept;

/** @type {(inputs: Community_Invite_AcceptInputs) => LocalizedString} */
const zh_community_invite_accept = en_community_invite_accept;

/** @type {(inputs: Community_Invite_AcceptInputs) => LocalizedString} */
const ar_community_invite_accept = en_community_invite_accept;

/** @type {(inputs: Community_Invite_AcceptInputs) => LocalizedString} */
const it_community_invite_accept = en_community_invite_accept;

/** @type {(inputs: Community_Invite_AcceptInputs) => LocalizedString} */
const ru_community_invite_accept = en_community_invite_accept;

/** @type {(inputs: Community_Invite_AcceptInputs) => LocalizedString} */
const pt_community_invite_accept = en_community_invite_accept;

/** @type {(inputs: Community_Invite_AcceptInputs) => LocalizedString} */
const ko_community_invite_accept = en_community_invite_accept;

/**
* | output |
* | --- |
* | "Accept Invitation" |
*
* @param {Community_Invite_AcceptInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const community_invite_accept = /** @type {((inputs?: Community_Invite_AcceptInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Invite_AcceptInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_community_invite_accept(inputs)
	if (locale === "es") return es_community_invite_accept(inputs)
	if (locale === "fr") return fr_community_invite_accept(inputs)
	if (locale === "de") return de_community_invite_accept(inputs)
	if (locale === "ja") return ja_community_invite_accept(inputs)
	if (locale === "zh") return zh_community_invite_accept(inputs)
	if (locale === "ar") return ar_community_invite_accept(inputs)
	if (locale === "id") return id_community_invite_accept(inputs)
	if (locale === "it") return it_community_invite_accept(inputs)
	if (locale === "ru") return ru_community_invite_accept(inputs)
	if (locale === "pt") return pt_community_invite_accept(inputs)
	return ko_community_invite_accept(inputs)
});